<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M24.5 21.875H23.625V4.375C23.625 4.14294 23.5328 3.92038 23.3687 3.75628C23.2046 3.59219 22.9821 3.5 22.75 3.5H16.625C16.3929 3.5 16.1704 3.59219 16.0063 3.75628C15.8422 3.92038 15.75 4.14294 15.75 4.375V8.75H10.5C10.2679 8.75 10.0454 8.84219 9.88128 9.00628C9.71719 9.17038 9.625 9.39294 9.625 9.625V14H5.25C5.01794 14 4.79538 14.0922 4.63128 14.2563C4.46719 14.4204 4.375 14.6429 4.375 14.875V21.875H3.5C3.26794 21.875 3.04538 21.9672 2.88128 22.1313C2.71719 22.2954 2.625 22.5179 2.625 22.75C2.625 22.9821 2.71719 23.2046 2.88128 23.3687C3.04538 23.5328 3.26794 23.625 3.5 23.625H24.5C24.7321 23.625 24.9546 23.5328 25.1187 23.3687C25.2828 23.2046 25.375 22.9821 25.375 22.75C25.375 22.5179 25.2828 22.2954 25.1187 22.1313C24.9546 21.9672 24.7321 21.875 24.5 21.875ZM17.5 5.25H21.875V21.875H17.5V5.25ZM11.375 10.5H15.75V21.875H11.375V10.5ZM6.125 15.75H9.625V21.875H6.125V15.75Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "GeneralIcon",
};
</script>
